import { getTenant, orgSearch } from '../helpers';
import { api } from './api';


function parseEarnedSkills(data) {
  return data.map(item => ({
    id: item.skill.id,
    name: item.skill.name,
    skillType: 'earned',
  }));
}

export function getUserEarnedSkillsAPI(username: string, callback) {
  api.iblaxdApiCallWrapper(
    (args) => api.iblaxdskillsapi.skillsOrgsSkillsUsersRetrieve(...args),
    getTenant(),
    username,
  )((err, data, response) => callback(parseEarnedSkills(response.body)));
}

export function getUserEarnedSkillsNewFormat(username: string, callback) {
  const params = new URLSearchParams({
    username,
    platform_key:getTenant()
  }).toString()
  const url = `${process.env.REACT_APP_IBL_DM_URL}/api/catalog/milestones/skill_points/user/?${params}`
  fetch(url, {
    method:"GET",
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + localStorage.getItem('dm_token'),
    },
  }).then((resp)=>{
     const contentType = resp.headers.get('content-type');
    if (contentType && contentType.includes('application/json')) {
      resp.json().then((data)=>{
      if(data && typeof data === 'object' && Object.keys(data).length > 0){
        const skillsNames = Object.keys(data)
        callback(skillsNames.map((_skillName, index)=>({
          id:index,
          name:_skillName,
          skillType: 'earned',
        })))
      }else{
        callback([])
      }
    })
    }else {
       callback([])
    }
  }).catch(()=>{
    callback([])
  })
}



export function getUserHighlightedSkillsAPI(username, callback) {
  const data = {
    username: username,
    platform_key: getTenant(),
  };
  api.ibldmskills.getUserSkills(data, function(data) {
    data = parseHighlightedSkills(data);
    callback(data);
  }, function(error) {
    if (error.status === 400) {
      callback([]);
    }
  });
}

export function addSelfReportedSkillAPI(skillData, callback) {
  api.ibldmskills.addSelfReportedSkill(skillData, function(data) {
    callback(data);
  });
}

export function addHighlightedSkillAPI(skillData, callback) {
  api.ibldmskills.addDesiredSkill(skillData, function(data) {
    callback(data);
  });
}

export function getUserSelfReportedSkillsAPI(username, callback) {
  const data = {
    username: username,
    platform_key: getTenant(),
  };
  api.ibldmskills.getUserSelfReportedSkills(data, function(data) {
      data = parseSelfReportedSkills(data);
      callback(data);
    },
    function(error) {
      if (error.status === 400) {
        callback(null);
      }
    },
  );
}

export function parseSelfReportedSkills(data) {
  if (
    !data ||
    !data?.skills ||
    !Array.isArray(data?.skills) ||
    !data?.data ||
    !data?.data?.level
  ) {
    // Handle invalid or missing data
    return null;
  }

  return data?.skills?.map((skill, index) => {
    const { id, name } = skill;
    const levelValue = data?.data?.level[index];

    return {
      id,
      name,
      skillType: 'selfReported',
      starCount: levelValue ? parseInt(levelValue, 10) : 0,
    };
  });
}

export function parseHighlightedSkills(data) {
  if (!data || !data?.skills || !Array.isArray(data?.skills)) {
    // Handle invalid or missing data
    return [];
  }

  return data?.skills?.map((skill) => {
    const { id, name } = skill;

    return {
      id,
      name,
      skillType: 'highlighted',
    };
  });
}

export function skillsSearchAPI(searchTerm, callback) {
  searchTerm = searchTerm.toLowerCase();
  const queryParam = new URLSearchParams({
    content: 'skills',
    ...(searchTerm
      ? {
        query: searchTerm,
      }
      : {}),
  });
  const url = `${process.env.REACT_APP_IBL_DM_URL}/api/search/catalog/?${queryParam}`;
  fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + localStorage.getItem('dm_token'),
    },
  })
    .then((resp) => {
      resp.json().then((response) => {
        callback(response);
      });
    })
    .catch(() => {
      callback({ results: [] });
    });
}

